/** GP50 maneuver cheat sheet columns (maneuver-cheat-sheet API, group_by=channel). */

export type Gp50ManeuverType = "tack" | "gybe" | "roundup" | "bearaway";

export const GP50_MANEUVER_TYPE_OPTIONS: { label: string; value: Gp50ManeuverType }[] = [
  { label: "TACK", value: "tack" },
  { label: "GYBE", value: "gybe" },
  { label: "ROUNDUP", value: "roundup" },
  { label: "BEARAWAY", value: "bearaway" },
];

/** Metric column keys returned by maneuver-cheat-sheet (excluding config). */
export const GP50_MANEUVER_METRIC_COLUMN_KEYS = [
  "bsp_drop",
  "drop_time",
  "turn_rate_max",
  "twa_exit",
  "overshoot_angle",
  "raise_time",
  "time_two_boards",
  "pitch_accmax",
  "heel_accmax",
  "cant_eff_accmax",
  "wing_twist_accmax",
  "wing_clew_pos_accmax",
  "jib_sheet_pct_accmax",
  "jib_lead_ang_accmax",
  "loss_inv_tgt",
  "loss_turn_tgt",
  "loss_build_tgt",
  "loss_total_tgt",
] as const;

export type Gp50ManeuverMetricColumnKey = (typeof GP50_MANEUVER_METRIC_COLUMN_KEYS)[number];

export const GP50_MANEUVER_COLUMN_HEADERS: Record<string, string> = {
  config: "CONFIG",
  bsp_drop: "BSP DROP [KPH]",
  drop_time: "DROP TIME [S]",
  turn_rate_max: "TURN RATE MAX [DEG/SEC]",
  twa_exit: "TWA EXIT [DEG]",
  overshoot_angle: "OVERSHOOT ANGLE [DEG]",
  raise_time: "RAISE TIME [S]",
  time_two_boards: "TWO BOARD TIME [S]",
  pitch_accmax: "PITCH [DEG]",
  heel_accmax: "HEEL [DEG]",
  cant_eff_accmax: "CANT EFF [DEG]",
  wing_twist_accmax: "WING TWIST [DEG]",
  wing_clew_pos_accmax: "WING CLEW POS [MM]",
  jib_sheet_pct_accmax: "JIB SHT [%]",
  jib_lead_ang_accmax: "JIB LEAD [DEG]",
  loss_inv_tgt: "LOSS INV [M]",
  loss_turn_tgt: "LOSS TURN [M]",
  loss_build_tgt: "LOSS BUILD [M]",
  loss_total_tgt: "LOSS TOTAL [M]",
  record_count: "Count",
};

export function gp50ManeuverColumnHeader(key: string): string {
  return GP50_MANEUVER_COLUMN_HEADERS[key.toLowerCase()] ?? key;
}

export function isGp50ManeuverHeatmapColumn(key: string): boolean {
  const kl = key.toLowerCase();
  return kl !== "config" && kl !== "record_count";
}

/** Performance Drivers: UPWIND → tack SHAP, DOWNWIND → gybe SHAP; no maneuvers for REACHING. */
export type Gp50PerformanceDriversPointOfSail = "UPWIND" | "DOWNWIND" | "REACHING";

export function gp50PerformanceDriversManeuverType(
  pointOfSail: Gp50PerformanceDriversPointOfSail
): "tack" | "gybe" | null {
  if (pointOfSail === "UPWIND") return "tack";
  if (pointOfSail === "DOWNWIND") return "gybe";
  return null;
}

export function gp50PerformanceDriversManeuverLabel(
  pointOfSail: Gp50PerformanceDriversPointOfSail
): string {
  if (pointOfSail === "UPWIND") return "TACK";
  if (pointOfSail === "DOWNWIND") return "GYBE";
  return "";
}
